import getTitle from 'helpers/getTitle'
import Translate from 'modules/local/Translate'
import React from 'react'
import {NullAsDefault} from 'views/Shared'
import {GradeActionTypes} from '../../../AppLocals/Course'
import {GoDotFill} from 'react-icons/go'
import {Link} from 'react-router-dom'
import getLinkToDetail from '../../../../helpers/getLinkToDetail'

export const renderCourseClassGrade =
    ({ renderContextMenu = NullAsDefault, handleAction = NullAsDefault } = {}) =>
        (item, index) => {
            const { subject, total_students_has_score, total_students } = item ?? {}

            return (
                <Translate key={index}>
                    {(t) => (
                        <div className="relative px-3 py-2 flex flex-col background rounded-xl hover:shadow-md" style={{ transition: 'transform 0.15s', transform: 'scale(1)' }}>

                            {/* Main content */}
                            <div className="flex flex-col flex-1">

                                {/* Title row */}
                                <div
                                    onClick={() => handleAction(GradeActionTypes.GRADE_DETAIL, item)}
                                    className="flex items-center cursor-pointer"
                                    style={{ gap: '0.5rem' }}
                                >
                                <span className="font-normal text-color-400 flex-shrink-0">
                                    {`${index + 1}.`}
                                </span>
                                    <span
                                        className="flex-1 font-bold text-base text-color-000 hover:text-primary overflow-hidden"
                                        style={{
                                            display: '-webkit-box',
                                            WebkitLineClamp: 1,
                                            WebkitBoxOrient: 'vertical',
                                            overflow: 'hidden',
                                        }}
                                    >
                                    {getTitle(item)}
                                </span>
                                </div>

                                {/* Meta row */}
                                <div className="flex flex-wrap items-center italic" style={{ gap: '0.5rem', marginTop: '0.25rem' }}>

                                    {/* Subject */}
                                    {subject && (
                                        <div className="flex items-center text-xs" style={{ gap: '0.25rem' }}>
                                            <GoDotFill size={10} className="text-color-400 flex-shrink-0" />
                                            <span className="text-color-400">
                                            {`${t('subjects')} : `}
                                        </span>
                                            <span className="font-semibold text-color-100">
                                            {getTitle(subject)}
                                        </span>
                                        </div>
                                    )}

                                    {/* Graded count */}
                                    {total_students && (
                                        <div className="flex items-center text-xs" style={{ gap: '0.25rem' }}>
                                            <GoDotFill size={10} className="text-color-400 flex-shrink-0" />
                                            <span className="text-color-400">
                                            {`${t('graded')} : `}
                                        </span>
                                            <span className="font-semibold text-color-100">
                                            {total_students_has_score}/{total_students}
                                        </span>
                                        </div>
                                    )}

                                    {/* Exam actions */}
                                    {!!item?.course_class_exam?.id && (
                                        <div className="flex items-center ml-auto" style={{ gap: '0.75rem' }}>
                                            {item?.course_class_exam?.status === 1 && (
                                                <Link
                                                    to={getLinkToDetail(item?.course_class_exam)}
                                                    className="font-semibold px-2 text-sm text-primary-600 no-underline"
                                                >
                                                    {t('exam')}
                                                </Link>
                                            )}
                                            {!!item?.edit && !!item?.course_class_exam?.id && (
                                                <div
                                                    onClick={() =>
                                                        handleAction(
                                                            GradeActionTypes.COURSE_CLASS_EXAM_UPDATE,
                                                            item?.course_class_exam
                                                        )
                                                    }
                                                    className="font-semibold text-sm text-indigo-500 hover:text-primary cursor-pointer"
                                                    style={{ transition: 'color 0.2s' }}
                                                >
                                                    {t('edit exam')}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Context menu */}
                            {item?.course_class?.edit && renderContextMenu && (
                                <div className="absolute" style={{ top: '1.25rem', right: '1.25rem' }}>
                                    {renderContextMenu(item)}
                                </div>
                            )}
                        </div>
                    )}
                </Translate>
            )
        }